import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {generateStore, reduxStore} from './common/store';
import keycloakConnector from './common/service/keycloak';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import App from './App';
import './index.scss';

const store = generateStore([]);

const renderApp = () =>
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    document.getElementById('root')
  );

keycloakConnector.init(store, reduxStore, renderApp);
serviceWorkerRegistration.register();
reportWebVitals();
